import React from 'react'
import styled from 'styled-components'

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
`

const P1 = ({ className, children }) => (
  <Text className={className}>{children}</Text>
)

export default P1
